module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-cobranca-view', {
    ref: "cobrancaView"
  }), _vm._v(" "), _c('email-automatico-view', {
    ref: "emailAutomaticoView"
  }), _vm._v(" "), _c('copiar-lotes-view', {
    ref: "copiarLotesView"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.leilao !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('btn-status-confirmar', {
    ref: "confirmarStatus",
    attrs: {
      "Status": _vm.getStatus
    }
  }), _vm._v(" "), _c('grafico-leilao-dash', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v(_vm._s(_vm.leilao.titulo))]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }, [_vm._v(_vm._s(_vm.leilao.categoria ? _vm.leilao.categoria.nome : 'Sem Categoria'))]), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success "
  }, [_vm._v(_vm._s(_vm.HelperTipo(_vm.leilao.tipo)))]), _vm._v(" "), (_vm.leilao.leilaoJudicial) ? _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-warning"
  }, [_vm._v("Judicial")]) : _vm._e(), _vm._v(" "), (_vm.leilao.loteado) ? _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-primary"
  }, [_vm._v("Loteado")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('btn-controle', {
    attrs: {
      "leilao": _vm.leilao,
      "ACL": _vm.ACL,
      "currentUser": _vm.currentUser
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [(_vm.ACL.check('alterar_status_leilao', _vm.currentUser.id)) ? _c('button', {
    staticClass: "btn bg-light btn-sm",
    on: {
      "click": _vm.updateLinkLive
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-danger"
  }), _vm._v(" Atualizar live\n              ")]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('alterar_status_leilao', _vm.currentUser.id)) ? _c('btn-status', {
    staticClass: "hidden-print",
    attrs: {
      "Status": _vm.getStatus,
      "value": _vm.leilao.status
    },
    on: {
      "input": _vm.confirmarAlteracaoStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n              ")]), _vm._v(" "), _c('btn-relatorios', {
    staticClass: "hidden-print",
    attrs: {
      "leilao": _vm.leilao
    }
  }), _vm._v(" "), _c('btn-acoes', {
    attrs: {
      "leilao": _vm.leilao
    },
    on: {
      "renovarCache": _vm.renovarCache,
      "emailsAutomaticos": function($event) {
        return _vm.$refs.emailAutomaticoView.load(_vm.leilao.id)
      },
      "updateTransmissaoUrl": _vm.updateTransmissaoUrl
    }
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n              ")])], 1)]), _vm._v(" "), (_vm.ENV_INFRA === 'local') ? _c('div', {
    staticClass: "m-t"
  }, [(!_vm.sync) ? _c('u-button', {
    on: {
      "click": _vm.sincronizarLeilaoLocal
    }
  }, [_c('i', {
    staticClass: "fa fa-terminal m-r-xs"
  }), _vm._v(" Iniciar transição para leilão local\n            ")]) : _vm._e(), _vm._v(" "), (_vm.sync) ? _c('shell-sync', {
    attrs: {
      "shellResponse": _vm.shellResponse
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "m-t"
  }, [_vm._v("\n            Online...\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', [_c('img', {
    attrs: {
      "loading": "lazy",
      "src": require("assets/img/leilaoico.png"),
      "height": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v(_vm._s(_vm.leilao.resumo))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://www.rogeriomenezes.com.br/leilao/' + _vm.leilao.id
    }
  }, [_vm._v("www.rogeriomenezes.com.br/leilao/1")])]), _vm._v(" "), _c('p', [_vm._v("\n                  Publicação: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.leilao.dataPublicacao.date).format('LLLL')))]), _vm._v(" "), _c('br'), _vm._v("\n                  Abertura: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))]), _vm._v(" "), (_vm.leilao.autoFechamento) ? _c('span', {
    staticClass: "label bg-dark"
  }, [_vm._v("Automático")]) : _vm._e()]), _vm._v(" "), (_vm.leilao.tipo !== 1) ? _c('p', [_vm._v("Tempo do Pregão: "), _c('strong', [_vm._v(_vm._s(_vm.leilao.timerPregao) + " segundos")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.leilao.id))]), _vm._v(" "), _c('h5', [_vm._v("Criado " + _vm._s(_vm.moment(_vm.leilao.dataCadastro.date).calendar()))]), _vm._v(" "), _c('p', {
    staticClass: "m-t m-b"
  }, [_vm._v("Leilão Interno: "), _c('strong', [_vm._v(_vm._s(_vm.leilao.syncExtra ? _vm.leilao.syncExtra.codigoInterno : ''))]), _c('br'), _vm._v("\n                  ID Interno: "), _c('strong', [_vm._v("#" + _vm._s(_vm.leilao.syncId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "well m-t bg-light lt"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("LEILOEIRO:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.leilao.leiloeiro ? _vm.leilao.leiloeiro.pessoa.nome : 'Sem leiloeiro definido'))]), _vm._v(" "), _c('p', [(_vm.leilao.comissao) ? _c('span', [_vm._v("Comissão: " + _vm._s(_vm.leilao.comissao) + "% "), (_vm.leilao.cobraComissao) ? _c('span', {
    staticClass: "label bg-light"
  }, [_vm._v("Será cobrado")]) : _vm._e(), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.leilao.local) ? _c('div', [_c('strong', [_vm._v("LOCAL:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.leilao.local.nome))]), _vm._v(" "), _c('p', [_vm._v("\n                      " + _vm._s(_vm.leilao.local.descricao)), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("INFORMAÇÕES:")]), _vm._v(" "), _c('p', [_vm._v("\n                    Visitação: " + _vm._s(_vm.leilao.infoVisitacao)), _c('br'), _vm._v("\n                    Retirada: " + _vm._s(_vm.leilao.infoRetirada)), _c('br'), _vm._v("\n                    Observações: " + _vm._s(_vm.leilao.observacao)), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('h4', [_vm._v("Lotes "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.filteredDataLotes && _vm.filteredDataLotes.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('u-button', {
    staticClass: "btn btn-sm btn-success pull-right hidden-print m-b-sm",
    on: {
      "click": _vm.cadastraLote
    }
  }, [_vm._v("\n                  Cadastrar Lote\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right w-md m-r-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKey),
      expression: "filterKey"
    }],
    staticClass: "input-sm form-control hidden-print",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filterKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKey = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterKey) ? _c('span', {
    staticClass: "visible-print"
  }, [_vm._v("Filtro: " + _vm._s(_vm.filterKey))]) : _vm._e()]), _vm._v(" "), _c('u-button-group', {
    staticClass: "pull-right m-r",
    attrs: {
      "options": _vm.tiposLote
    },
    model: {
      value: (_vm.filtro.tipo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipo", $$v)
      },
      expression: "filtro.tipo"
    }
  }), _vm._v(" "), _c('filtro-status-lotes', {
    staticClass: "pull-right m-r",
    attrs: {
      "options": _vm.situacaoLote
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-print",
    staticStyle: {
      "max-width": "30px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'numero'
    },
    staticStyle: {
      "width": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numero')
      }
    }
  }, [_vm._v("\n                  LT "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'titulo'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('titulo')
      }
    }
  }, [_vm._v("\n                  DESCRIÇÃO "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['titulo'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'comitente'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('comitente')
      }
    }
  }, [_vm._v("\n                  COMITENTE "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['comitente'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("FIPE")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("MÍNIMO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap hidden-print",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("AVALIAÇÃO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("LANCE ATUAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("COBRANÇA")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("ARREMATE")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredDataLotes), function(lote) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item",
      class: _vm.bindClassLoteList(lote)
    }, [_c('td', {
      staticClass: "hidden-print",
      staticStyle: {
        "max-width": "30px"
      }
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lote.checked),
        expression: "lote.checked"
      }],
      attrs: {
        "type": "checkbox",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(lote.checked) ? _vm._i(lote.checked, null) > -1 : (lote.checked)
      },
      on: {
        "click": function($event) {
          return _vm.checkLote(lote)
        },
        "change": function($event) {
          var $$a = lote.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(lote, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(lote, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(lote, "checked", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "max-width": "30px"
      }
    }, [_vm._v(_vm._s(lote.numero))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-print"
    }, [_c('img', {
      attrs: {
        "loading": "lazy",
        "width": "50",
        "src": lote.urlMin
      }
    })]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: _vm.leilao.id,
            id: lote.id
          }
        }
      }
    }, [_vm._v(_vm._s(lote.titulo.toUpperCase()) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(lote.comitente ? lote.comitente : 'Sem comitente'))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorTabelaFipe)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorMinimo)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-print"
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorAvaliacao)))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.ultimoLanceValor)) + " "), (lote.ultimoLanceApelido && lote.ultimoLanceApelido === 'PLATEIA') ? _c('span', {
      staticClass: "label label-xs no-radius bg-white",
      attrs: {
        "title": "Plateia"
      }
    }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), (lote.ultimoLanceApelido && lote.ultimoLanceApelido !== 'PLATEIA') ? _c('span', {
      staticClass: "label label-xs no-radius bg-white text-success"
    }, [_vm._v(_vm._s(lote.ultimoLanceApelido) + "\n                   ")]) : _vm._e()]), _vm._v(" "), _c('td', [(lote.ultimoLanceApelido && lote.ultimoLanceApelido !== 'PLATEIA') ? _c('div', [_c('div', [(lote.status === 6) ? _c('button', {
      staticClass: "btn btn-xs m-l-xs",
      on: {
        "click": function($event) {
          return _vm.$refs.cobrancaView.load(_vm.leilao.id, lote.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      class: {
        'text-success': lote.comunicacao && lote.comunicacao.length > 0
      },
      attrs: {
        "title": "Gerar Cobrança"
      }
    }), _vm._v(" "), (lote.comunicacao && lote.comunicacao.length > 0) ? _c('span', {
      staticClass: "badge badge-sm up bg-primary pull-right-xs"
    }, [_vm._v(_vm._s(lote.comunicacao.length))]) : _vm._e()]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorArremate)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalMinimo)))]), _vm._v(" "), _c('td', {
    staticClass: "font-bold"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalMeta)))]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalArremate)))])]), _vm._v(" "), (_vm.leilao.cobraComissao) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Comissão " + _vm._s(_vm.leilao.comissao) + "%")])]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoMinimo)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoMeta)))]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoArremate)))])]) : _vm._e(), _vm._v(" "), (_vm.leilao.cobraTaxasAdicionais) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Taxa ICMS " + _vm._s(_vm.leilao.taxaIcms) + "%")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.leilao.cobraTaxasAdicionais) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Taxa ISS " + _vm._s(_vm.leilao.taxaIss) + "%")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.lotesChecked.length > 0) ? _c('div', {
    staticClass: "m-t-n m-b-lg"
  }, [_vm._v("\n              Ação para selecionados:\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionCheckedLotes),
      expression: "actionCheckedLotes"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actionCheckedLotes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm._actionCheckedLotes]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a ação")]), _vm._v(" "), (_vm.ACL.check('deletar_lote_leilao', _vm.currentUser.id)) ? _c('option', {
    attrs: {
      "value": "deletar"
    }
  }, [_vm._v("Excluir")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "copiar"
    }
  }, [_vm._v("Copiar para outro leilão")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('resumo-lances', {
    ref: "resumoLances",
    attrs: {
      "leilao": _vm.leilao
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary m-b ",
    on: {
      "click": function($event) {
        return _vm.$refs.resumoLances.open()
      }
    }
  }, [_vm._v("Resumo de Lances por comitente")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.leilao.comitentes), function(comitente) {
    return _c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "panel b-light clearfix"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('a', {
      staticClass: "pull-left m-r"
    }, [_c('img', {
      attrs: {
        "loading": "lazy",
        "src": comitente.imagem,
        "width": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }, [_c('a', {
      staticClass: "text-dark"
    }, [_vm._v(_vm._s(comitente.nome))]), _vm._v(" "), _c('small', {
      staticClass: "block text-muted"
    }, [_vm._v(_vm._s(comitente.lotes) + " lote" + _vm._s(comitente.lotes > 1 ? 's' : '') + "\n                      ")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v("Documentos públicos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('u-button', {
    staticClass: "btn btn-sm btn-default fileContainer pull-right hidden-print m-b-sm"
  }, [_vm._v("\n                  Cadastrar Documento\n                  "), _c('input', {
    ref: "fileDocumento",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadDocumento
    }
  })])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("DOCUMENTO")]), _vm._v(" "), _c('th', [_vm._v("ARQUIVO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.leilao.documentos), function(documento) {
    return _c('tr', {
      attrs: {
        "id": 'documento' + documento.id
      }
    }, [_c('td', [_vm._v(_vm._s(documento.nome))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": documento.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(documento.arquivo))])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.removeDocumento(documento.id)
        }
      }
    }, [_vm._v("Remover")])])])
  }), 0)])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.renovarCache($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hdd-o m-r-xs"
  }), _vm._v(" Renovar Cache\n          ")])], 1)])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eff5d5b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/VisualizarLeilao.vue
// module id = 781
// module chunks = 2